import type { CookieType } from 'src/types/cookie';

export const UPDATE_FEATURE_FLAGS = 'UPDATE_FEATURE_FLAGS';
export const OVERRIDE_FEATURE_FLAG = 'OVERRIDE_FEATURE_FLAG';

export interface FeatureFlagsState {
  branchBannerPreview: boolean;
  isBranchEnabledFlag: boolean;
  showHomepageBanner: boolean;
  showFloatingSaveSearch: boolean;
  autoSelectSplitViewFirstJob: boolean;
  showMarketingAdSplitView: boolean;
  loggedOutRecs: boolean;
  remoteSearchFilter: boolean;
  remoteSearchFilterNewLabel: boolean;
  keywordAutosuggestV2: boolean;
  serpJobCardInfoDensity1: boolean;
  hideCompanyLogo: boolean;
  entryLevelBadge: boolean;
  homepageRecsBadgingStrongApplicant: boolean;
  homepageJobCardDensity: boolean;
  homepageGenAIChat: boolean;
  homepageGenAIChatAltModel: boolean;
  homepageGenAIChatAltPosition: boolean;
  homepageGenAIChatMobileDrawer: boolean;
  homepageGenAIChatDesktopDrawer: boolean;
  competitivePlacementEmbeddedJdv: boolean;
  competitivePlacement: boolean;
  homeFeedAPI: boolean;
  careerFeedCompanyEvp?: boolean;
  overrides?: CookieType;
}

export type UpdateFeatureFlagsAction = {
  type: typeof UPDATE_FEATURE_FLAGS;
  payload: {
    dynamicFlags: Record<string, any>;
  };
};

export type OverrideFeatureFlagAction = {
  type: typeof OVERRIDE_FEATURE_FLAG;
  payload: {
    flag: string;
    value?: string;
  };
};

export type FeatureFlagsAction =
  | UpdateFeatureFlagsAction
  | OverrideFeatureFlagAction;

export type TFeatureFlagNames = keyof FeatureFlagsState;
